module.exports = __webpack_public_path__ + "img/pe.8188abed.png";